import React from "react";

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {}
const InputField = ({ ...props }: InputFieldProps) => {
  return (
    <input
      {...props}
    />
  );
};

export default InputField;
